import PropTypes from 'prop-types';
import { Link } from 'react-router';
import cn from 'classnames';

import SiteAwareMetadata from 'components/SiteAwareMetadata';
import ContinueShopping from 'components/cart/ContinueShopping';
import EmptyBox from 'images/empty-cart.svg';
import marketplace from 'cfg/marketplace.json';

import css from 'styles/components/cart/emptyCart.scss';

const { cart: { shopWomensUrl, shopMenUrl, shopShoesUrl, shopBrandText } } = marketplace;
export const EmptyCustomerCart = ({ onLinkClick }, { marketplace: { defaultMeta: { title }, cart: { cartName } } }) => (
    <>
      <p>Fill up your {cartName} by checking out all the awesome things you can buy on {title} or by adding items from Your Favorites</p>
      <div className={css.links}>
        <Link onClick={onLinkClick} to={shopWomensUrl}>Shop Women's</Link>
        <Link onClick={onLinkClick} to={shopMenUrl}>Shop Men's</Link>
        <Link className={css.shoes} onClick={onLinkClick} to={shopShoesUrl}>Shop Shoes</Link>
        <Link onClick={onLinkClick} to="/c/brands">{shopBrandText}</Link>
      </div>
    </>
);

EmptyCustomerCart.contextTypes = {
  marketplace: PropTypes.object
};

export const EmptyAnonymousCart = ({ onLinkClick }, { testId, marketplace: { defaultMeta: { title }, cart: { cartName } } }) => (
    <>
      <p>Nothing to see here Yet! Sign in to see items what you've previously placed in your {cartName} or check out all the awesome things you can buy on {title}</p>
      <div className={css.links}>
        <Link onClick={onLinkClick} to="/login">Sign In</Link>
        <Link onClick={onLinkClick} to="/" data-test-id={testId('homeLink')}>Home Page</Link>
        <Link onClick={onLinkClick} to="/c/brands">{shopBrandText}</Link>
        <Link onClick={onLinkClick} to="/c/contact-us">Contact Us</Link>
      </div>
    </>
);

EmptyAnonymousCart.contextTypes = {
  testId: PropTypes.func,
  marketplace: PropTypes.object
};

const EmptyCart = ({ onLinkClick, isCustomer, className, children }, { testId, marketplace: { cart: { cartName } } }) => (
  <SiteAwareMetadata>
    <div className={cn(css.container, className)} data-test-id={testId('emptyCart')}>

      <ContinueShopping />

      <h1>My {cartName}</h1>

      { isCustomer ? <EmptyCustomerCart onLinkClick={onLinkClick} /> : <EmptyAnonymousCart onLinkClick={onLinkClick} /> }
      <img src={EmptyBox} alt="" />

      { children }
    </div>
  </SiteAwareMetadata>
);

EmptyCart.contextTypes = {
  testId: PropTypes.func,
  marketplace: PropTypes.object
};

export default EmptyCart;
